'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapObject = mapObject;
exports.chunk = chunk;
exports.isEmpty = isEmpty;
exports.isBoolean = isBoolean;
exports.isEmptyObj = isEmptyObj;
exports.isVariableDefined = isVariableDefined;
exports.getUtcDateJson = getUtcDateJson;
exports.getDateJson = getDateJson;
exports.getCurrentDayLong = getCurrentDayLong;
exports.getCurrentDayShort = getCurrentDayShort;
exports.getDayShort = getDayShort;
exports.locale_date = locale_date;
exports.getMonthName = getMonthName;
exports.getMonthNameShort = getMonthNameShort;
exports.parseTime = parseTime;
exports.dateToHours = dateToHours;
exports.formatDateToHours = formatDateToHours;
exports.filter = filter;
exports.getOpenHoursString = getOpenHoursString;
exports.isGroupShownAfterHours = isGroupShownAfterHours;
exports.getOpeningHoursStr = getOpeningHoursStr;
exports.getTodaysOpeningDetails = getTodaysOpeningDetails;
exports.getTodaysOpeningHours = getTodaysOpeningHours;
exports.getOpeningHoursOfDay = getOpeningHoursOfDay;
exports.getOpeningHoursOfGivenDate = getOpeningHoursOfGivenDate;
exports.getIndividualHours = getIndividualHours;
exports.isResturantOpen = isResturantOpen;
exports.toRoundStr = toRoundStr;
exports.formatPhoneNumber = formatPhoneNumber;
exports.removeNonNumber = removeNonNumber;
exports.convertStringToPhoneNumberFormat = convertStringToPhoneNumberFormat;
exports.formatTime = formatTime;
exports.formatDateTimeWithTimeZone = formatDateTimeWithTimeZone;
exports.getAddressStrFromLocation = getAddressStrFromLocation;
exports.getLocationAddress = getLocationAddress;
exports.getAddressSearchStrFromLocation = getAddressSearchStrFromLocation;
exports.getDeliveryAddressSearchStr = getDeliveryAddressSearchStr;
exports.getLogoUrl = getLogoUrl;
exports.getCategoryMenuType = getCategoryMenuType;
exports.extractWebsiteConfig = extractWebsiteConfig;
exports.getDistanceInMeters = getDistanceInMeters;
exports.convertMilesInMeters = convertMilesInMeters;
exports.getMeterInMiles = getMeterInMiles;
exports.getDeliveryRange = getDeliveryRange;
exports.convertJqueryToParsePromise = convertJqueryToParsePromise;
exports.fbLogoutUser = fbLogoutUser;
exports.googleLogoutUser = googleLogoutUser;
exports.logOut = logOut;
exports.signOutGuest = signOutGuest;
exports.logOutAll = logOutAll;
exports.updateUserAcl = updateUserAcl;
exports.filterByProperty = filterByProperty;
exports.getOrderStateLabel = getOrderStateLabel;
exports.isUserSessionInvalid = isUserSessionInvalid;
exports.checkErrorIsInvalidSessionToken = checkErrorIsInvalidSessionToken;
exports.refreshCurrentParseUser = refreshCurrentParseUser;
exports.showSpinner = showSpinner;
exports.hideSpinner = hideSpinner;
exports.changeTimezone = changeTimezone;
exports.checkIfImageExists = checkIfImageExists;
exports.formatGoogleApplePayPhoneNumber = formatGoogleApplePayPhoneNumber;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _reactRouterDom = require('react-router-dom');

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _libphonenumberJs = require('libphonenumber-js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapObject(object, callback) {
    return Object.keys(object).map(function (key) {
        return callback(key, object[key]);
    });
}

function chunk(arr, len) {
    var chunks = [],
        i = 0,
        n = arr.length;

    while (i < n) {
        chunks.push(arr.slice(i, i += len));
    }

    return chunks;
}

function isEmpty(str) {
    // console.log(str)
    return !str || str.length === 0;
}

function isBoolean(val) {
    return val === false || val === true;
}

function isEmptyObj(obj) {
    if (!obj) {
        return true;
    }
    return Object.getOwnPropertyNames(obj).length === 0;
}

// created function to check variable defined or not
function isVariableDefined(variable) {
    if (typeof variable !== 'undefined') {
        // the variable is defined
        return true;
    } else {
        return false;
    }
}

function getUtcDateJson(date) {

    if (!date) {
        date = new Date();
    }

    return {
        "__type": "Date",
        "iso": date.toISOString()
    };
}

function getDateJson(dateString) {

    return {
        "__type": "Date",
        "iso": dateString
    };
}

// Not used
function getCurrentDayLong() {
    var d = new Date();
    var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return days[d.getDay()];
}

function getCurrentDayShort(date) {

    var dateTime = date;

    var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return days[dateTime.getDay()];
}

function getDayShort(day) {
    var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return days[day];
}

function locale_date() {
    return {
        en: {
            month_names: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            month_names_short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }
    };
}

function getMonthName(month) {
    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";

    return this.locale_date()[lang].month_names[month];
}

function getMonthNameShort(month) {
    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";

    return this.locale_date()[lang].month_names_short[month];
}

function parseTime(timeStr, dt) {
    var re1 = '(\\d+)'; // Integer Number 1
    var re2 = '(?:\\:)'; // Any Single Character 1
    var re3 = '(\\d+)'; // Integer Number 2
    var re4 = '(?:\\s*)'; // White Space 1
    var re5 = '(am|AM|pm|PM)'; // Word 1

    var pattern = new RegExp(re1 + re2 + re3 + re4 + re5, ["i"]);

    if (!dt) {
        dt = new Date();
    } else {
        dt = new Date(dt.getTime());
    }

    var timeMatch = pattern.exec(timeStr);

    if (!timeMatch) {
        return NaN;
    }
    var hours = parseInt(timeMatch[1], 10);
    var AMPM = timeMatch[3];

    if (AMPM === "PM" && hours < 12) hours = hours + 12;
    if (AMPM === "AM" && hours === 12) hours = hours - 12;

    dt.setHours(hours);
    dt.setMinutes(parseInt(timeMatch[2], 10) || 0);
    dt.setSeconds(0, 0);
    return dt;
}

function dateToHours(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var suffix = hours >= 12 ? 'PM' : 'AM';
    var hh = (hours + 11) % 12 + 1;
    var hh2 = (hh < 10 ? "0" : "") + hh;

    var mm = (minutes < 10 ? "0" : "") + minutes;
    var formattedTime = hh2 + ":" + mm + " " + suffix;
    return formattedTime;
}

function formatDateToHours(date, currentDate) {

    // let currentDate = new Date();

    var day = date.getDay();
    var dayShortName = this.getDayShort(day);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var suffix = hours >= 12 ? 'PM' : 'AM';
    var hh = (hours + 11) % 12 + 1;
    var mm = (minutes < 10 ? "0" : "") + minutes;

    var formattedTime = "";

    if (date.toDateString("YYYY-MM-DD") == currentDate.toDateString("YYYY-MM-DD")) {
        formattedTime = hh + ":" + mm + " " + suffix;
    } else {
        formattedTime = dayShortName + " " + hh + ":" + mm + " " + suffix;
    }
    return formattedTime;
}

// Filtering based on object keys
function filter(obj, predicate) {
    var result = {};
    var key = void 0;
    for (key in obj) {
        if (obj.hasOwnProperty(key) && predicate(key)) {
            result[key] = obj[key];
        }
    }
    return result;
}

function getOpenHoursString(openHours, dateTime) {
    var _this = this;

    var data = [];
    var WEEK_DAYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

    var key = void 0;
    for (key in WEEK_DAYS) {
        var day = WEEK_DAYS[key];

        if (!this.isEmptyObj(openHours)) {

            var openHour = openHours[day];
            if (openHour && openHour.toUpperCase() != 'CLOSED') {
                var timeRanges = openHour.split("|");

                var individualHours = timeRanges.map(function (timeRange) {
                    return timeRange.split("-").map(function (time) {
                        return _this.parseTime(time, dateTime);
                    });
                });

                if (individualHours.length > 0) {
                    var dailyHours = void 0;
                    var dailyDataArray = [];
                    for (dailyHours in individualHours) {

                        var newDateArray = [];
                        newDateArray.push(this.dateToHours(individualHours[dailyHours][0]));
                        newDateArray.push(this.dateToHours(individualHours[dailyHours][1]));
                        dailyDataArray.push(newDateArray);
                    }

                    data[day] = dailyDataArray;
                }
            } else {
                data[day] = ["CLOSED"];
            }
        }
    }
    return data;
}

function isGroupShownAfterHours(groupDetail, dateTime) {
    var defaultGroupVisible = true;

    if (groupDetail != null) {

        if (groupDetail.hideAfterHours && groupDetail.openHours != null) {

            var groupOpenHours = groupDetail.openHours;
            // let currentTime = new Date();

            var isGroupAvailable = this.isResturantOpen(groupOpenHours, dateTime);

            return isGroupAvailable;
        }
    }
    return defaultGroupVisible;
}

function getOpeningHoursStr(openHours, date) {

    var today = this.getCurrentDayShort(date);
    var result = this.filter(openHours, function (key) {
        return today.toUpperCase() === key.toUpperCase();
    }.bind(this));

    if (this.isEmptyObj(result)) {
        return 'CLOSED';
    } else {
        return JSON.stringify(result);
    }
}

// Not used
function getTodaysOpeningDetails(openHours) {
    return this.filter(openHours, function (key) {
        var today = this.getCurrentDayShort();
        return today.toUpperCase() === key.toUpperCase();
    }.bind(this));
}

function getTodaysOpeningHours(openHours, dateTime) {

    var todaysOpeningHour = this.filter(openHours, function (key) {
        var today = this.getCurrentDayShort(dateTime);
        return today.toUpperCase() === key.toUpperCase();
    }.bind(this));

    return todaysOpeningHour[this.getCurrentDayShort(dateTime).toUpperCase()];
}

// Not used
function getOpeningHoursOfDay(openHours, dayShortStr) {
    var todaysOpeningHour = this.filter(openHours, function (key) {
        return dayShortStr.toUpperCase() === key.toUpperCase();
    }.bind(this));

    return todaysOpeningHour[this.getCurrentDayShort().toUpperCase()];
}

function getOpeningHoursOfGivenDate(openHours, date) {
    var dayShortStr = this.getDayShort(date.getDay());
    return openHours[dayShortStr.toUpperCase()];
}

function getIndividualHours(todaysTime) {
    var onDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var timeRanges = todaysTime.split("|");

    var individualHours = timeRanges.map(function (timeRange) {
        return timeRange.split("-").map(function (time) {
            return this.parseTime(time, onDate);
        }.bind(this));
    }.bind(this));

    return individualHours;
}

function isResturantOpen() {
    var openHours = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var onDate = arguments[1];


    var todaysOpeningHour = this.filter(openHours, function (key) {
        var today = this.getCurrentDayShort(onDate);
        return today.toUpperCase() === key.toUpperCase();
    }.bind(this));

    if (this.isEmptyObj(todaysOpeningHour)) {
        return true;
    }

    var todaysTime = todaysOpeningHour[this.getCurrentDayShort(onDate).toUpperCase()];
    if (!todaysTime) {
        return false;
    }

    var timeRanges = todaysTime.split("|");

    var individualHours = timeRanges.map(function (timeRange) {
        return timeRange.split("-").map(function (time) {
            return this.parseTime(time, onDate);
        }.bind(this));
    }.bind(this));

    var today = new Date();

    if (onDate) {
        today = new Date(onDate.getTime());
    }

    var result = individualHours.some(function (individualHour) {
        return individualHour[0] <= today && today <= individualHour[1];
    });

    return result;
}

function toRoundStr(number, precision) {
    return _lodash2.default.round(number, precision).toFixed(precision);
}

function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) {
        return phoneNumber;
    }

    var phone = phoneNumber.replace(/[^\d]/g, "");

    if (phone.length === 10) {
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    } else {
        return phone;
    }
}

function removeNonNumber(phoneNumber) {

    if (!phoneNumber) {
        return phoneNumber;
    }

    phoneNumber = phoneNumber.replace('(', '');
    phoneNumber = phoneNumber.replace(')', '');
    phoneNumber = phoneNumber.replace(' ', '');
    phoneNumber = phoneNumber.replace('-', '');
    phoneNumber = phoneNumber.replace('_', '');
    phoneNumber = phoneNumber.replace('+', '');

    return phoneNumber;
}

function convertStringToPhoneNumberFormat(value) {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;

    // clean the input for any non-digit values.
    var phoneNumber = value.replace(/[^\d]/g, "");

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    var phoneNumberLength = phoneNumber.length;

    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you  format the area code to early
    if (phoneNumberLength < 4) return phoneNumber;

    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    if (phoneNumberLength < 7) {
        return '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3);
    }

    // finally, if the phoneNumberLength is greater then seven, we add the last
    // bit of formatting and return it.
    return '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6, 10);
    // }
}

function formatTime(date) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-us";

    var options = {
        weekday: "long", year: "numeric", month: "short",
        day: "numeric", hour: "2-digit", minute: "2-digit"
    };

    var formattedTime = "";

    if (date != null) {
        formattedTime = date.toLocaleTimeString(locale, options);
    }

    return formattedTime;
}

function formatDateTimeWithTimeZone(date, timeZone) {
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-us";

    var options = {
        timeZone: timeZone,
        weekday: "long", year: "numeric", month: "short",
        day: "numeric", hour: "2-digit", minute: "2-digit"
    };

    // console.log(options);

    var formattedTime = "";

    if (date != null) {
        formattedTime = date.toLocaleTimeString(locale, options);
    }

    return formattedTime;
}

function getAddressStrFromLocation(locationBar) {
    var address = "";
    var addLineStr = "";

    if (locationBar != null) {
        if (locationBar.addLine1) {
            addLineStr = locationBar.addLine1;
        }

        if (locationBar.addLine2) {
            addLineStr = addLineStr + ' ' + locationBar.addLine2;
        }

        address = addLineStr + ',\n                \n ' + locationBar.city + ', ' + locationBar.state + '  ' + locationBar.zipCode + ',\n                ' + this.formatPhoneNumber(locationBar.phoneNumber);
    }
    return address;
}

function getLocationAddress(locationBar) {
    // let address = "";
    var addLineStr = "";

    if (locationBar != null) {
        if (locationBar.addLine1) {
            addLineStr = locationBar.addLine1;
        }

        if (locationBar.addLine2) {
            addLineStr = addLineStr + ' ' + locationBar.addLine2;
        }

        // address = `${addLineStr},
        // \n ${locationBar.city}, ${locationBar.state}  ${locationBar.zipCode},
        // ${this.formatPhoneNumber(locationBar.phoneNumber)}`;
    }
    return addLineStr;
}

function getAddressSearchStrFromLocation(locationBar) {
    var address = "";
    var addLineStr = "";

    if (locationBar != null) {
        if (locationBar.addLine1) {
            addLineStr = locationBar.addLine1;
        }

        if (locationBar.addLine2) {
            addLineStr = addLineStr + ' ' + locationBar.addLine2;
        }
        address = addLineStr + ', ' + locationBar.city + ', ' + locationBar.state + ' - ' + locationBar.zipCode;
    }
    return address;
}

function getDeliveryAddressSearchStr(addressObj) {
    var address = "";
    var addLineStr = "";

    if (addressObj != null) {
        if (addressObj.addLine1) {
            addLineStr = addressObj.addLine1;
        }

        if (addressObj.addLine2) {
            addLineStr = addLineStr + ' ' + addressObj.addLine2;
        }
        address = addLineStr + ', ' + addressObj.city + ', ' + addressObj.state + ' - ' + addressObj.zipCode;
    }
    return address;
}

function getLogoUrl(containerObject) {
    if (this.isEmptyObj(containerObject)) {
        return "";
    }

    if (containerObject.logoURL) {
        return containerObject.logoURL;
    }

    if (!this.isEmptyObj(containerObject.logo)) {
        return containerObject.logo.url;
    }

    return "";
}

function getCategoryMenuType(businessDetail) {
    //if ( locationDetail && !this.isEmptyObj(locationDetail.websiteConfig.categoryMenuType)) {
    //return locationDetail.websiteConfig.categoryMenuType;
    //}
    return "V";
}

function extractWebsiteConfig(websiteConfig, property) {
    if (!this.isEmptyObj(websiteConfig) && (!this.isEmptyObj(websiteConfig[property]) || websiteConfig[property])) {
        return websiteConfig[property];
    }
    return null;
}

function getDistanceInMeters(distance) {
    if (distance.endsWith("mi")) {
        return _lodash2.default.round(distance.match(/\d+/)[0] * 1609, 2);
    } else if (distance.endsWith("km")) {
        return _lodash2.default.round(distance.match(/\d+/)[0] * 1000, 2);
    } else if (distance.endsWith("m")) {
        return _lodash2.default.round(distance.match(/\d+/)[0], 2);
    }
}

function convertMilesInMeters(distanceInMiles) {
    // if (!distanceInMiles){
    //     return;
    // }
    return _lodash2.default.round(distanceInMiles * 1609, 2);
}

function getMeterInMiles(distance) {

    // if (this.isEmpty(distance)) {
    //     return null;
    // }
    return _lodash2.default.round(distance / 1609, 2);
}

function getDeliveryRange(fee) {
    /*		"feeType" : "fixed | percentage",
            "minAmount" : 40
            "fee" : {
            "0-2" : 0
            "2-5" : 5
            }*/

    //let fee = {
    //"0-2" : 0,
    //"2-5" : 5,
    //"5-10": 10
    //};

    var rangeMap = {};
    Object.keys(fee).forEach(function (key) {
        var endRange = void 0;
        if (key.indexOf("-") != -1) {
            endRange = key.split("-")[1];
        } else {
            endRange = key;
        }
        rangeMap[endRange] = fee[key];
    });
    return rangeMap;
}

function convertJqueryToParsePromise(jqueryPromise) {
    var promise = new _parse2.default.Promise();
    jqueryPromise.then(function (results) {
        promise.resolve(results);
    }, function (error) {
        promise.reject(error);
    });
    return promise;
}

function fbLogoutUser() {
    FB.getLoginStatus(function (response) {
        if (response && response.status === 'connected') {
            FB.logout(function (response) {
                console.log('User signed out from facebook.');
            });
        }
    });
}

function googleLogoutUser() {
    // When the user signs out we need to call the method
    // google.accounts.id.disableAutoSelect to signout user.
    google.accounts.id.disableAutoSelect();
    console.log('User signed out from google.');
}

function logOut(router, locId) {
    var _this2 = this;

    var clearStoresData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (clearStoresData) {
        _Actions2.default.clearScheduleScreenStore(true);
        _Actions2.default.clearCartStore();
        _Actions2.default.resetPaymentMethod();
        // console.log("clear store")
        // Actions.resetCustomChargeDataOfCart();
        // Actions.resetDeliveryAddress();
    }

    // Actions.resetScheduledDate();

    _parse2.default.User.logOut().then(function (success) {
        _parse2.default.User._clearAllState();
        _parse2.default.User._clearCache();
        _Actions2.default.informLoginChange(null);
        if (!_this2.isEmpty(locId)) {
            router.push('/location/' + locId);
        }

        _this2.hideSpinner();
    }, function (error) {
        console.log(JSON.stringify(error));
        if (error.code === _parse2.default.Error.INVALID_SESSION_TOKEN) {
            _Actions2.default.informLoginChange(null);
            if (!_this2.isEmpty(locId)) {
                router.push('/location/' + locId);
            }
            _this2.hideSpinner();
        }
    });
}

//signOut guest user if validation fails in stripe after creating guest User.
function signOutGuest(router) {
    _parse2.default.User.logOut().then(function (success) {
        _parse2.default.User._clearAllState();
        _parse2.default.User._clearCache();
        _Actions2.default.informLoginChange(null);
        router.push('/');
    }, function (error) {
        console.log(JSON.stringify(error));
        if (error.code === _parse2.default.Error.INVALID_SESSION_TOKEN) {
            _Actions2.default.informLoginChange(null);
            router.push('/');
        }
    });
}

function logOutAll(router, locId) {
    var clearStoresData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    this.logOut(router, locId, clearStoresData);
    this.fbLogoutUser();
    this.googleLogoutUser();
}

function updateUserAcl(user) {
    var currentUser = null;
    if (!user) {
        currentUser = _parse2.default.User.current();
    } else {
        currentUser = user;
    }
    if (!currentUser) {
        return;
    }
    var oldAcl = currentUser.getACL();
    if (!oldAcl || oldAcl.getPublicReadAccess() || oldAcl.getPublicWriteAccess()) {
        var acl = new _parse2.default.ACL(currentUser);
        currentUser.setACL(acl);
        return currentUser.save();
    } else {
        return _parse2.default.Promise.as(currentUser);
    }
}

function filterByProperty(itemMap, key, value) {
    var i,
        j,
        hash = [],
        item;

    for (var k in itemMap) {
        if (typeof itemMap[k] !== 'function') {
            // alert("Key is " + k + ", value is" + array[k]);
            item = itemMap[k];

            if (typeof item[key] !== "undefined" && item[key].trim() === value.trim()) {
                hash.push(item);
            }
        }
    }
    if (hash.length > 0) {
        return hash[0];
    }

    return null;
}

function getOrderStateLabel(orderState) {
    var orderStateArray = {
        "Created": "NEW",
        "Accepted": "ACCEPTED",
        "OutForDelivery": "OUT FOR DELIVERY",
        "ReadyForPickUp": "READY FOR PICKUP",
        "Delivered": "DELIVERED",
        "PickedUp": "PICKED UP",
        "Rejected": "REJECTED",
        "NotCompleted": "NOT COMPLETED"
    };

    if (orderState) {
        return orderStateArray[orderState];
    } else {
        return "";
    }
}

// check the session is valid or not
function isUserSessionInvalid() {
    return _parse2.default.Session.current();
}

// check the error message and show the alert box
function checkErrorIsInvalidSessionToken(error, router, locId, clearCart) {
    if (error != null && error.responseJSON != null && error.responseJSON.error != null) {
        var errorCode = error.responseJSON.error.code;
        var errorMessage = error.responseJSON.error.message;
        if (errorCode == _parse2.default.Error.INVALID_SESSION_TOKEN) {

            _sweetalert2.default.fire({
                title: 'User session expired',
                text: errorMessage,
                icon: 'warning',
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'Close',
                customClass: {
                    cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                },
                allowOutsideClick: false
            });

            this.logOut(router, locId, clearCart);
        } else {
            // alert("Error: Some error occured! Try Again!");
        }
    } else if (error != null && error.code != null) {
        var _errorCode = error.code;
        var _errorMessage = error.message;
        if (_errorCode == _parse2.default.Error.INVALID_SESSION_TOKEN) {

            _sweetalert2.default.fire({
                title: 'User session expired',
                text: _errorMessage,
                icon: 'warning',
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'Close',
                customClass: {
                    cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                },
                allowOutsideClick: false
            });

            this.logOut(router, locId, clearCart);
        } else {
            // alert("Error: Some error occured! Try Again!");
        }
    }
}

function refreshCurrentParseUser() {
    _parse2.default.User.current().fetch().then(function (user) {

        console.log("Current parse user updated");
        // silent console log after update the current parse user
        // console.log(JSON.stringify(user));
    }, function (error) {
        // silent console log after update the current parse user
        console.log(JSON.stringify(error));
    });
}

function showSpinner() {
    var spinnerDiv = document.getElementById("spinner-container-box");

    if (spinnerDiv) {
        // spinner div id is "spinner-container-box"
        document.getElementById("spinner-container-box").style.display = "inline";
        //  document.getElementById("main-spinner").style.display = "block";
    }
}

function hideSpinner() {
    var spinnerDiv = document.getElementById("spinner-container-box");

    if (spinnerDiv) {
        // spinner div id is "spinner-container-box"
        spinnerDiv.style.display = "none";
        // document.getElementById("main-spinner").style.display = "none";
    }
}

function changeTimezone(date, timeZone) {

    // suppose the date is 12:00 UTC
    var invdate = new Date(date.toLocaleString('en-US', {
        timeZone: timeZone
    }));

    // then invdate will be 07:00 in Toronto
    // and the diff is 5 hours
    var diff = date.getTime() - invdate.getTime();

    // so 12:00 in Toronto is 17:00 UTC
    return new Date(date.getTime() - diff); // needs to substract
}

function checkIfImageExists(url, callback) {

    var img = new Image();

    img.src = url;

    if (img.complete) {
        callback(true);
    } else {
        img.onload = function () {
            callback(true);
        };
        img.onerror = function () {
            callback(false);
        };
    }
}

function formatGoogleApplePayPhoneNumber(ev) {
    var rawPhoneNumber = ev.payerPhone || '';

    // Check if rawPhoneNumber is not empty
    if (this.isEmpty(rawPhoneNumber)) {
        return "0000000000";
    }

    // Parse the phone number to extract the country code
    var phoneNumber = (0, _libphonenumberJs.parsePhoneNumberFromString)(rawPhoneNumber);

    // Extract the country code or use an empty string if not present
    var countryCode = phoneNumber ? '+' + phoneNumber.countryCallingCode : '';

    // Remove the extracted country code from the phone number if it's present
    var cleanedPhoneNumber = rawPhoneNumber.startsWith(countryCode) ? rawPhoneNumber.slice(countryCode.length) : rawPhoneNumber;

    // Remove any non-digit characters from the phone number
    cleanedPhoneNumber = cleanedPhoneNumber.replace(/\D/g, '');

    // If the cleaned phone number is less than 10 digits, add leading zeros
    if (cleanedPhoneNumber.length < 10) {
        var numberOfZerosToAdd = 10 - cleanedPhoneNumber.length;
        var leadingZeros = '0'.repeat(numberOfZerosToAdd);
        return leadingZeros + cleanedPhoneNumber;
    }

    // If the cleaned phone number is 10 or more digits, return the last 10 digits
    return cleanedPhoneNumber.slice(-10);
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/Utility.jsx
// module id = 233
// module chunks = 0